<div class="schedule-tab">
  <div class="two-column-layout">
    <!-- Left Column: Tables -->
    <div class="left-column">
      <div class="time-off-header">
        <button 
          class="btn btn-primary add-event-btn" 
          (click)="showAddDialog()"
          [disabled]="!isEditMode">
          <i class="fa fa-plus"></i> Add Schedule
        </button>
      </div>

  <div class="time-off-table-container">
    <p-table
      [value]="dailySchedules"
      [loading]="isLoadingSchedules"
      tableStyleClass="time-off-table"
      responsiveLayout="scroll"
      [sortMode]="'single'">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="dayOfWeek">
            <div class="table-header-cell">
              DAY OF WEEK
              <p-sortIcon field="dayOfWeek"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="open">
            <div class="table-header-cell">
              OPEN
              <p-sortIcon field="open"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="close">
            <div class="table-header-cell">
              CLOSE
              <p-sortIcon field="close"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="notes">
            <div class="table-header-cell">
              NOTES
              <p-sortIcon field="notes"></p-sortIcon>
            </div>
          </th>
          <th class="actions-column" *ngIf="isEditMode"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record>
        <tr>
          <td>{{ getDayOfWeekName(record.dayOfWeek) }}</td>
          <td>
            <span *ngIf="!record.closedAllDay">{{ record.open || "N/A" }}</span>
            <span *ngIf="record.closedAllDay" class="closed-all-day">Closed</span>
          </td>
          <td>
            <span *ngIf="!record.closedAllDay">{{ record.close || "N/A" }}</span>
            <span *ngIf="record.closedAllDay" class="closed-all-day">Closed</span>
          </td>
          <td>{{ record.notes || "" }}</td>
          <td class="actions-cell" *ngIf="isEditMode">
            <i 
              class="fa fa-pencil action-icon edit-icon" 
              (click)="editScheduleRecord(record)" 
              title="Edit"></i>
            <i 
              class="fa fa-trash action-icon delete-icon" 
              (click)="deleteScheduleRecord(record)" 
              title="Delete"></i>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="isEditMode ? 5 : 4" class="empty-message">
            No schedule records found.
          </td>
        </tr>
      </ng-template>
    </p-table>
      </div>

      <!-- Location Events Section -->
      <div class="time-off-header" style="margin-top: 30px;">
        <button 
          class="btn btn-primary add-event-btn" 
          (click)="showAddEventDialog()"
          [disabled]="!isEditMode">
          <i class="fa fa-plus"></i> Add Location Event
        </button>
      </div>

      <div class="time-off-table-container">
        <p-table
          [value]="locationEvents"
          [loading]="isLoadingEvents"
          tableStyleClass="time-off-table"
          responsiveLayout="scroll"
          [sortMode]="'single'">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="startDate">
                <div class="table-header-cell">
                  START DATE
                  <p-sortIcon field="startDate"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="endDate">
                <div class="table-header-cell">
                  END DATE
                  <p-sortIcon field="endDate"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="locationEventType">
                <div class="table-header-cell">
                  EVENT TYPE
                  <p-sortIcon field="locationEventType"></p-sortIcon>
                </div>
              </th>
              <th pSortableColumn="notes">
                <div class="table-header-cell">
                  NOTES
                  <p-sortIcon field="notes"></p-sortIcon>
                </div>
              </th>
              <th class="actions-column" *ngIf="isEditMode"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-record>
            <tr>
              <td>{{ record.startDate | date : "MM/dd/yyyy" }}</td>
              <td>{{ record.endDate | date : "MM/dd/yyyy" }}</td>
              <td>{{ getEventTypeName(record.locationEventType) }}</td>
              <td>{{ record.notes || "" }}</td>
              <td class="actions-cell" *ngIf="isEditMode">
                <i 
                  class="fa fa-pencil action-icon edit-icon" 
                  (click)="editEventRecord(record)" 
                  title="Edit"></i>
                <i 
                  class="fa fa-trash action-icon delete-icon" 
                  (click)="deleteEventRecord(record)" 
                  title="Delete"></i>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="isEditMode ? 5 : 4" class="empty-message">
                No location events found.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Right Column: Calendar -->
    <div class="right-column">
      <div class="calendar-container">
        <p-calendar 
          [(ngModel)]="selectedDate" 
          [inline]="true"
          [showWeek]="false"
          (onSelect)="onCalendarSelect($event)">
          <ng-template pTemplate="date" let-date>
            <span 
              [ngStyle]="getDateStyle(date)" 
              class="calendar-date"
              [class.has-event]="hasEventsOnDate(date)"
              [pTooltip]="getDateTooltip(date)"
              [tooltipDisabled]="!hasEventsOnDate(date)"
              tooltipPosition="top"
              (click)="onCalendarDateClick($event)">
              {{ date.day }}
            </span>
          </ng-template>
        </p-calendar>
      </div>
    </div>
  </div>

  <!-- Add/Edit Schedule Dialog -->
  <p-dialog 
    [(visible)]="displayDialog" 
    [header]="isEditingRecord ? 'Edit Daily Schedule' : 'Add Daily Schedule'"
    [modal]="true"
    [style]="{width: '500px'}"
    [draggable]="false"
    [resizable]="false"
    (onShow)="onDialogShow()">
    <div class="dialog-content">
      <div class="form-group">
        <label for="dayOfWeek">Day of Week <span class="required">*</span></label>
        <p-dropdown 
          [(ngModel)]="newScheduleRecord.dayOfWeek"
          [options]="dayOfWeekOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Day of Week"
          inputId="dayOfWeek"
          [style]="{'width': '100%'}"
          [disabled]="isEditingRecord">
        </p-dropdown>
      </div>

      <div class="form-group">
        <label>
          <p-checkbox 
            [(ngModel)]="newScheduleRecord.closedAllDay"
            [binary]="true"
            inputId="closedAllDay"
            (onChange)="onClosedAllDayChange()">
          </p-checkbox>
          <span style="margin-left: 8px;">Closed All Day</span>
        </label>
      </div>

      <div class="form-group" *ngIf="!newScheduleRecord.closedAllDay">
        <label for="open">Open Time <span class="required">*</span></label>
        <input 
          type="time"
          id="open"
          class="form-control"
          [(ngModel)]="newScheduleRecord.open"
          placeholder="HH:mm"
          required>
      </div>

      <div class="form-group" *ngIf="!newScheduleRecord.closedAllDay">
        <label for="close">Close Time <span class="required">*</span></label>
        <input 
          type="time"
          id="close"
          class="form-control"
          [(ngModel)]="newScheduleRecord.close"
          placeholder="HH:mm"
          required>
      </div>

      <div class="form-group">
        <label for="notes">Notes</label>
        <textarea 
          id="notes"
          class="form-control"
          [(ngModel)]="newScheduleRecord.notes"
          rows="3"
          placeholder="Enter notes">
        </textarea>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button class="btn btn-default" (click)="closeDialog()">Cancel</button>
      <button class="btn btn-primary" (click)="saveScheduleRecord()">Save</button>
    </ng-template>
  </p-dialog>

  <!-- Add/Edit Event Dialog -->
  <p-dialog 
    [(visible)]="displayEventDialog" 
    [header]="isEditingEvent ? 'Edit Location Event' : 'Add Location Event'"
    [modal]="true"
    [style]="{width: '500px'}"
    [draggable]="false"
    [resizable]="false"
    (onShow)="onEventDialogShow()">
    <div class="dialog-content">
      <div class="form-group">
        <label for="startDate">Start Date <span class="required">*</span></label>
        <p-calendar 
          [(ngModel)]="newEventRecord.startDate"
          dateFormat="mm/dd/yy"
          [style]="{'width' : '100%'}"
          [showIcon]="true"
          [readonlyInput]="false"
          [showOnFocus]="false"
          [appendTo]="'body'"
          inputId="startDate">
        </p-calendar>
      </div>

      <div class="form-group">
        <label for="endDate">End Date <span class="required">*</span></label>
        <p-calendar 
          [(ngModel)]="newEventRecord.endDate"
          dateFormat="mm/dd/yy"
          [style]="{'width' : '100%'}"
          [showIcon]="true"
          [readonlyInput]="false"
          [showOnFocus]="false"
          [appendTo]="'body'"
          inputId="endDate">
        </p-calendar>
      </div>

      <div class="form-group">
        <label for="eventType">Event Type <span class="required">*</span></label>
        <p-dropdown 
          [(ngModel)]="newEventRecord.locationEventType"
          [options]="getEventTypeOptions()"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Event Type"
          inputId="eventType"
          [style]="{'width': '100%'}">
        </p-dropdown>
      </div>

      <div class="form-group">
        <label for="eventNotes">Notes</label>
        <textarea 
          id="eventNotes"
          class="form-control"
          [(ngModel)]="newEventRecord.notes"
          rows="3"
          placeholder="Enter notes">
        </textarea>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button class="btn btn-default" (click)="closeEventDialog()">Cancel</button>
      <button class="btn btn-primary" (click)="saveEventRecord()">Save</button>
    </ng-template>
  </p-dialog>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>

